import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { removeItemFromCart, updateItemQuantity } from "./cartSlice";
import { LogIn } from "lucide-react";
import CartItems from "../../components/common/modals/CartItems";
import CartSummary from "../../components/common/modals/CartSummary";

export default function Main() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const cartItems = useSelector((state) => state.cart.items);
  const loading = useSelector((state) => state.cart.loading);
  const hasItems = Array.isArray(cartItems) && cartItems.length > 0;

  const handleRemoveFromCart = (item) => {
    if (!user) {
      navigate("/login");
      return;
    }
    dispatch(
      removeItemFromCart({ user_id: user.idUser, product_id: item.product_id }),
    );
  };

  const handleUpdateQuantity = (product_id, newMenge) => {
    const maxMenge = 10;
    if (newMenge < 1 || newMenge > maxMenge) return;

    dispatch(
      updateItemQuantity({
        user_id: user.idUser,
        product_id,
        menge: newMenge,
      }),
    );
  };

  if (!user) {
    return (
      <div className="kn-page flex flex-col items-center justify-center mt-24 px-6">
        <div className="kn-card p-8 max-w-md w-full text-center">
          <div className="flex justify-center mb-4">
            <LogIn className="h-12 w-12 text-knapp-accent" />
          </div>
          <h1 className="kn-h3 mb-2">Sie sind nicht eingeloggt</h1>
          <p className="kn-body mb-6">
            Bitte melden Sie sich an, um Ihren Warenkorb anzusehen.
          </p>
          <button onClick={() => navigate("/login")} className="kn-btn-primary">
            Zum Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="kn-page">
      {loading && (
        <div className="fixed top-0 left-0 right-0 z-50">
          <div className="mx-2 mt-1 h-[2px] bg-gray-300 opacity-80 rounded-full animate-pulse" />
        </div>
      )}

      <main className="mx-auto w-full max-w-[1240px] px-5 sm:px-8 lg:px-12 pt-10 pb-20">
        <div className="kn-eyebrow">Bestellung</div>
        <h1 className="kn-h1 mt-3">Warenkorb</h1>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(320px,420px)] gap-7 items-start mt-7">
          <section className="min-w-0 flex flex-col gap-3.5">
            <CartItems
              cartItems={cartItems}
              user={user}
              onUpdateQuantity={handleUpdateQuantity}
              onRemoveItem={handleRemoveFromCart}
            />
            {hasItems && (
              <div className="flex flex-wrap gap-3 items-center justify-between mt-1.5">
                <Link
                  to="/produkte"
                  className="text-[15px] font-semibold underline"
                >
                  Weiter einkaufen
                </Link>
              </div>
            )}
          </section>

          {hasItems && (
            <aside className="min-w-0 w-full lg:sticky lg:top-20">
              <CartSummary cartItems={cartItems} />
            </aside>
          )}
        </div>
      </main>
    </div>
  );
}
